import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('glTagsDescriptionCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/ledger/tags/params/descriptions'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.ledgerTag,
    cacheName: 'glTagsDescription'
  })
);